<template>

  <v-container fluid class="page page-receiver-list">

    <!-- Breadcrumb & Actions -->
    <v-row class="mt-3 mb-6">
      <v-col cols="12" xs="12" sm="6" md="5" lg="4" class="d-flex align-center justify-start page-breadcrumb-new">
        <!-- (breadcrumb) -->
        <v-icon small class="mr-2">mdi-store</v-icon>
        <div>Receiver Locations</div>
      </v-col>
      <v-col cols="12" xs="12" sm="6" md="7" lg="8" class="d-flex align-center justify-xs-start justify-sm-end justify-md-end justify-lg-end">
        <v-icon class="pr-1" color="primary">mdi-history</v-icon>
        <router-link class="item-link" :to="{ name: 'receiver-license-history' }">
          License Change History
        </router-link>
      </v-col>
    </v-row>

    <!-- Sys-Admin Notifications -->
    <location-sys-admin-notifications
        class="mb-5"
        locationType="receiver"
        v-if="uiType === 'sys-admin'" />

    <!-- Shipper Notifications -->
    <location-shipper-notifications
        class="mb-5"
        locationType="receiver"
        v-if="uiType === 'shipper'" />

    <!-- Receiver Location List -->
    <receiver-location-list-data-table />

  </v-container>

</template>

<script>
import LocationSysAdminNotifications from '@/components/locations/LocationSysAdminNotifications'
import LocationShipperNotifications from '@/components/locations/LocationShipperNotifications'
import ReceiverLocationListDataTable from '@/components/receiverLocations/ReceiverLocationListDataTable'

export default {
  name: 'ReceiverListPage',

  components: {
    LocationSysAdminNotifications,
    LocationShipperNotifications,
    ReceiverLocationListDataTable
  },

  computed: {
    uiType () {
      return this.$root.uiType()
    }
  }
}
</script>

<style scoped>
  a.item-link {
    text-decoration: none;
  }

  a.item-link:hover {
    text-decoration: underline;
  }
</style>
